import { IOpoDocument } from './opo-document';

export interface IOpoProfile {
    optnName: string,
    optnAlias: string,
    legalName: string,
    website: string,
    opoRegion: number | null,
    timezone: string,
    isTaxExempt: boolean | null,
    taxExemptExpirationDate: string | null,
    achRoutingNumber: string,
    achAccountNumberMasked: string
}

export interface IOpoProfileRequest {
    optnName: string,
    optnAlias: string,
    legalName: string,
    website: string,
    opoRegion: number | null,
    timezone: string,
    isTaxExempt: boolean | null,
    taxExemptExpirationDate: string | null,
    achRoutingNumber: string,
    achAccountNumber: string
}

export interface IOptnRegionOption {
    id: number,
    regionNumber: number,
    states: string
}

export interface IOpoProfileData {
    profile: IOpoProfile,
    canEdit: boolean,
    documents: IOpoDocument[],
    regions: IOptnRegionOption[]
}
